/** * 预约号源弹窗 */
<template>
  <van-popup
    v-model="show"
    closeable
    close-icon="close"
    position="bottom"
    class="appointment-schedule-number-picker"
  >
    <div v-if="getInfo" class="appointment-schedule-number-picker-date">
      {{ `${getInfo.date} ${getInfo.week}${getInfo.am}` }}
    </div>
    <div v-if="getInfo" class="appointment-schedule-number-picker-doctor-info">
      {{ `${getInfo.doctorName} ${getInfo.departmentName}` }}
    </div>
    <div class="appointment-schedule-number-picker-number-list">
      <div
        v-for="(item, index) in numberList"
        :key="index"
        @click="check(item)"
      >
        {{ `${item.appointmentTime.substr(0, 5)} 号数 ${item.waitNumber}` }}
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  model: {
    prop: "showModal",
    event: "hideActionSheet"
  },
  props: {
    showModal: Boolean,
    doctorInfo: {
      type: Object,
      default: () => {}
    },
    numberList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      show: false
    };
  },
  computed: {
    getInfo() {
      if (this.numberList.length) {
        const info = this.numberList[0];
        return {
          date: info.appointmentDate.replace(/(.{4})(.{2})(.{2})/, "$2-$3"),
          week: info.week,
          am: info.timeFrameCode === "A" ? "上午" : "下午",
          doctorName: info.appointDoctorName || this.doctorInfo.doctorName,
          departmentName:
            info.departmentName ||
            info.appointOfficeName ||
            this.doctorInfo.departmentName
        };
      }
      return null;
    }
  },
  watch: {
    showModal(value) {
      this.show = value;
    },
    show(value) {
      this.$emit("hideActionSheet", value);
    }
  },
  methods: {
    check(item) {
      this.show = false;
      this.$emit("dateSelected", item);
    }
  }
};
</script>

<style lang="less" scoped>
.appointment-schedule-number-picker {
  max-height: 80%;

  &-date {
    margin: 1rem 0 0 0.75rem;
  }

  &-doctor-info {
    margin: 0.2rem 0.75rem;
    color: #959595;
  }

  &-number-list {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    font-size: 0.8rem;

    div {
      width: calc((100% - 2.9rem) / 3);
      margin: 0.2rem;
      padding: 0.2rem;
      text-align: center;
      border: solid 1px #dcdcdc;
      border-radius: 3px;
    }
  }
}
</style>
